import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

// 1. CORREÇÃO DO CSS: Adicionado '../' para voltar uma pasta, assumindo que 'styles' está na raiz do 'src'
import '../styles/QuemSomos.css';


const QuemSomos = () => {

  return (
    <>
      <Helmet>
        <title>Quem Somos | Especialistas em Revisão de Aposentadoria</title>
        <meta
          name="description"
          content="Conheça a equipe do Revisa Já Aposentadoria. Especialistas em direito previdenciário focados em garantir seus direitos no INSS."
        />
        <meta
          name="keywords"
          content="quem somos, especialistas em aposentadoria, revisão de aposentadoria, equipe previdenciária, sobre a empresa"
        />
        <meta property="og:title" content="Conheça o Revisa Já Aposentadoria" />
        <meta
          property="og:description"
          content="Advogados especialistas em revisão de aposentadoria e benefícios do INSS. Conheça nossa missão."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://revisajaaposentadoria.com.br/quem-somos" />
        <meta property="og:image" content="https://revisajaaposentadoria.com.br/og-quem-somos.png" />

        <link rel="canonical" href="https://revisajaaposentadoria.com.br/quem-somos" />
      </Helmet>


      <div className="quem-somos-page">
        <section id="quem-somos" className="quem-somos-wrapper">

        <div className="quem-somos-logo-box">
          <img src="/assets/logo.svg" alt="Revisa Já Logo" className="logo"></img>
        </div>

<div className="quem-somos-texto">
            <h2>Quem Somos</h2>
            <p>Somos a Revisa Já Assessoria (CNPJ: 68.027.310/0001-33), desenvolvedora e gestora do Sistema Revisa Já Aposentadoria. Toda a nossa operação conta com o respaldo técnico e jurídico do escritório do Dr. Jerônimo Magalhães (OAB-RJ 55.572), sediado na Rua Viúva Dantas, 80, Sala 312, Campo Grande - RJ.</p>
            <h2>Nossa Missão</h2>
            <p>Oferecer segurança, exatidão e justiça financeira ao aposentado. Identificamos erros materiais na concessão de benefícios previdenciários a partir de análises minuciosas do CNIS e da Carta de Concessão, entregando um serviço de alta qualidade a baixo custo.</p>
            <h2>Propósito</h2>
            <p>Descomplicar o processo de revisão de aposentadorias. Fornecemos um relatório completo e um pedido de revisão já personalizado para que o cidadão possa buscar seus direitos sem burocracia.</p>
           <br></br>
            <p>* Para o Aposentado: Uma solução justa, onde você só paga pelo uso da plataforma para descobrir se o seu dinheiro está correto.<br></br><br></br></p>
            <p>* Para o Advogado: Uma ferramenta indispensável de triagem e captação de clientes. Com um custo operacional mínimo, o profissional do Direito ganha escala, agilidade e argumentos sólidos para novas ações previdenciárias.</p>
          </div>

        </section>
      </div>
    </>
  );
};

export default QuemSomos;